// extracted by mini-css-extract-plugin
export var page5 = "page5-module--page5--ZUPBA";
export var animation = "page5-module--animation--BCiNl";
export var container = "page5-module--container--IghPG";
export var en = "page5-module--en--kVlgC";